import './styles/css/app.css';

import React from 'react';
import ReactDOM from 'react-dom';
import { useStrict } from 'mobx';
import { Provider } from 'mobx-react';
import { Router } from 'react-router-dom';
import createBrowserHistory from 'history/createBrowserHistory';
import { syncHistoryWithStore } from 'mobx-react-router';

import App from './App';
import { RootStore } from 'stores';
import { config } from 'config';
import { GlobalErrorBoundary } from 'common/error';
import registerServiceWorker from './registerServiceWorker';
import Modal from 'react-modal';

useStrict(true);

String.prototype.trim = function() {
    return this.replace(/^\s+|\s+$/g,"");
}
String.prototype.ltrim = function() {
    return this.replace(/^\s+/,"");
}
String.prototype.rtrim = function() {
    return this.replace(/\s+$/,"");
}

function createHistory(routingStore) {
    const browserHistory = createBrowserHistory();
    return syncHistoryWithStore(browserHistory, routingStore); 
}

Modal.setAppElement('#root')
function renderApp(rootStore, history) {
    ReactDOM.render(
        <Provider {...rootStore}>
            <GlobalErrorBoundary>
                <Router history={history}>
                    <App />
                </Router>
            </GlobalErrorBoundary> 
        </Provider>
        , document.getElementById('root')
    );
} 

function createStore() {
    const rootStore = new RootStore();
    return rootStore;
}

const rootStore = createStore();
const history = createHistory(rootStore.routerStore);

renderApp(
    rootStore,
    history
);

registerServiceWorker();



// WEBPACK FOOTER //
// ./src/index.js